var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "well well-no-shadow prelative pb-7" }, [
    _c("div", { staticClass: "header" }, [
      _c("h3", { staticClass: "mt-0 mb-1" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("h4", { staticClass: "mt-0 mb-3" }, [_vm._v(_vm._s(_vm.subtitle))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "content" },
        _vm._l(_vm.cells, function(cell) {
          return _c(
            "div",
            { key: cell.label, staticClass: "dinlineb span_4" },
            [
              _c("span", { staticClass: "block info-label" }, [
                _vm._v(_vm._s(cell.label))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "block info-value" }, [
                _vm._v(_vm._s(cell.amount))
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "pabsolute bottom-3 right-3 fs-3 link",
          attrs: { type: "text", href: _vm.link.link }
        },
        [_vm._v(" " + _vm._s(_vm.link.label) + " ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }